import React from "react";
import ReactDOM from "react-dom/client";
import TagManager from 'react-gtm-module'
import App from "./App";
 
const tagManagerArgs = {
  gtmId: 'GTM-MFHHTB9'
}

TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
